import React from "react";
import { connect } from "react-redux";
import InfoBar from "containers/request/InfoBar/dhr/InfoBarDHR";

const DHRInfoBarContainer = ({ request, wizard }) => {
  if (!request) return null;
  if (request.formSaved) return null;
  if (wizard && wizard.step === 1) return null;

  return <InfoBar />;
};

function mapStateToProps({ request, wizard }) {
  return { request, wizard };
}

export default connect(mapStateToProps)(DHRInfoBarContainer);
